// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1jjq8","noInteraction":"EventWrapper_noInteraction__10oqJ"};